import { ModelIcon } from 'src/types/models/ModelIcon';
import { IconName } from 'src/components/Icon';
import {
  NINJA_AGENT_AS_EXTERNAL_MODEL,
  NINJA_AGENT_IMAGE_AUTO_MODEL,
  NINJA_AGENT_TEXT_AUTO_MODEL,
  SUPER_AGENT_DEEP_RESEARCH_MODEL,
} from 'src/constants';

export const NINJA_AUTO_MODELS = [
  NINJA_AGENT_IMAGE_AUTO_MODEL,
  NINJA_AGENT_TEXT_AUTO_MODEL,
];

export const modelIconsMap: Record<ModelIcon, IconName> = {
  [ModelIcon.NINJATECH]: 'ninjaOutlined',
  [ModelIcon.NINJATECH_SUPER_AGENT]: 'ninjaPixProLogo',
  [ModelIcon.AMAZON_NOVA]: 'nova',
  [ModelIcon.ANTHROPIC]: 'claudeLogo',
  [ModelIcon.COHERE]: 'cohereLogo',
  [ModelIcon.DEEPSEEK]: 'deepSeekLogo',
  [ModelIcon.GOOGLE_GEMINI]: 'googleGeminiProLogo',
  [ModelIcon.MISTRAL]: 'mistralLogo',
  [ModelIcon.OPENAI]: 'chatGPTLogo',
  [ModelIcon.STABLE_DIFFUSION]: 'bedrockStableLogo',
  [ModelIcon.LLAMA]: 'metaLogoJSX',
  [ModelIcon.ALIBABA]: 'alibabaLogoJSX',
  [ModelIcon.XAI]: 'xaiLogoJSX',
};

export const newExternalModelsList: Record<
  string,
  {
    icon_name: IconName;
    display_name: string;
  }
> = {
  [NINJA_AGENT_TEXT_AUTO_MODEL]: {
    display_name: 'Ninja Auto-selects AI model',
    icon_name: 'ninjaOutlined',
  },
  [NINJA_AGENT_AS_EXTERNAL_MODEL]: {
    display_name: 'Fine-tuned Llama 3.3 70B',
    icon_name: 'ninjaOutlined',
  },
  [SUPER_AGENT_DEEP_RESEARCH_MODEL]: {
    display_name: 'SuperAgent Deep Research',
    icon_name: 'ninjaPixProLogo',
  },
  'alias/ninjatech/super-agent:turbo': {
    display_name: 'Turbo 1.0',
    icon_name: 'ninjaPixProLogo',
  },
  'alias/ninjatech/super-agent:nexus': {
    display_name: 'SuperAgent Nexus',
    icon_name: 'ninjaPixProLogo',
  },
  'alias/ninjatech/super-agent:apex': {
    display_name: 'Apex 1.0',
    icon_name: 'ninjaPixProLogo',
  },
  'alias/ninjatech/super-agent:reasoning': {
    display_name: 'Reasoning 2.0',
    icon_name: 'ninjaPixProLogo',
  },
  'alias/amazon/nova-micro': {
    display_name: 'Amazon Nova Micro',
    icon_name: 'nova',
  },
  'alias/amazon/nova-lite': {
    display_name: 'Amazon Nova Lite',
    icon_name: 'nova',
  },
  'alias/amazon/nova-pro': {
    display_name: 'Amazon Nova Pro',
    icon_name: 'nova',
  },
  'alias/amazon/titan-text-g1-express': {
    display_name: 'Titan Text G1–Express',
    icon_name: 'awsLogo',
  },
  'alias/amazon/titan-text-g1-lite': {
    display_name: 'Titan Text G1–Lite',
    icon_name: 'awsLogo',
  },
  // deprecated
  'alias/amazon/titan-text-premier': {
    display_name: 'Amazon Titan Text Premier',
    icon_name: 'awsLogo',
  },
  'alias/anthropic/claude-3.5-haiku': {
    icon_name: 'claudeLogo',
    display_name: 'Claude 3.5 Haiku',
  },
  'alias/anthropic/claude-3.5-sonnet': {
    icon_name: 'claudeLogo',
    display_name: 'Claude 3.5 Sonnet',
  },
  'alias/anthropic/claude-3.7-sonnet': {
    icon_name: 'claudeLogo',
    display_name: 'Claude 3.7 Sonnet',
  },
  'alias/cohere/command-r': {
    icon_name: 'cohereLogo',
    display_name: 'Command R',
  },
  'alias/cohere/command-r-plus': {
    icon_name: 'cohereLogo',
    display_name: 'Command R+',
  },
  'alias/mistral/mistral-small': {
    icon_name: 'mistralLogo',
    display_name: 'Mistral Small',
  },
  'alias/mistral/mistral-large': {
    icon_name: 'mistralLogo',
    display_name: 'Mistral Large',
  },
  'alias/deepseek/deepseek-v3': {
    icon_name: 'deepSeekLogo',
    display_name: 'DeepSeek V3',
  },
  'alias/deepseek/deepseek-r1': {
    icon_name: 'deepSeekLogo',
    display_name: 'DeepSeek R1',
  },
  'alias/openai/gpt-4o-mini': {
    icon_name: 'chatGPTLogo',
    display_name: 'GPT-4o Mini',
  },
  'alias/openai/gpt-4o': {
    icon_name: 'chatGPTLogo',
    display_name: 'GPT-4o',
  },
  'alias/openai/gpt-4.1-mini': {
    icon_name: 'chatGPTLogo',
    display_name: 'GPT-4.1 Mini',
  },
  'alias/openai/gpt-4.1': {
    icon_name: 'chatGPTLogo',
    display_name: 'GPT-4.1',
  },
  'alias/google/gemini-1.5-flash': {
    icon_name: 'googleGeminiProLogo',
    display_name: 'Gemini 1.5 Flash',
  },
  'alias/google/gemini-1.5-pro': {
    icon_name: 'googleGeminiProLogo',
    display_name: 'Gemini 1.5 Pro',
  },
  'alias/google/gemini-2.0-flash': {
    icon_name: 'googleGeminiProLogo',
    display_name: 'Gemini 2.0 Flash',
  },
  'agent/ninjatech/image-auto': {
    display_name: 'Ninja Auto-selects AI model',
    icon_name: 'ninjaOutlined',
  },
  'alias/ninjatech/ninja-pixart': {
    display_name: 'PixArt',
    icon_name: 'ninjaOutlined',
  },
  'alias/ninjatech/flux': {
    display_name: 'FLUX Schnell',
    icon_name: 'ninjaOutlined',
  },
  'alias/ninjatech/flux-pro': {
    display_name: 'FLUX 1.1 PRO',
    icon_name: 'ninjaOutlined',
  },
  // deprecated
  'alias/amazon/titan-image-generator': {
    display_name: 'Amazon Titan Image Generator',
    icon_name: 'awsLogo',
  },
  // deprecated
  'alias/amazon/nova-canvas': {
    display_name: 'Amazon Nova Canvas',
    icon_name: 'nova',
  },
  'alias/stability/stable-diffusion-xl': {
    display_name: 'Stable Diffusion XL 1.0',
    icon_name: 'bedrockStableLogo',
  },
  'alias/openai/dall-e-3': {
    display_name: 'DALL-E 3',
    icon_name: 'chatGPTLogo',
  },
  'alias/meta/llama-4-maverick': {
    display_name: 'Llama 4 Maverick',
    icon_name: 'metaLogoJSX',
  },
  'alias/meta/llama-4-scout': {
    display_name: 'Llama 4 Scout',
    icon_name: 'metaLogoJSX',
  },
  'alias/alibaba/qwen-3-32b': {
    display_name: 'Qwen 3 32B',
    icon_name: 'alibabaLogoJSX',
  },
  'alias/xai/grok4': {
    display_name: 'Grok 4 (Preview)',
    icon_name: 'xaiLogoJSX',
  },
};
